export default "__VITE_ASSET__mQBHqRRh__"